export const settings = {
    baseServingSize: 4,
    servingSizes: [4, 8, 16]
}